import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import * as d3 from "d3";
import * as topojson from "topojson";
import "d3-scale";

"use strict";
const map_defs = {
    "countries.geo.json": {
        "class": "country",
        "feature": "countries",
        "caption_prop": "admin",
        "key_prop": (d)=>d.id,
        scale: 0.2,
        projection: function() { return d3.geoMercator(); },
        translation: [0.5, 0.5],
        rotation: [0,0],
        center: [0,0]
    },
    "world-countries.json": {
        "class": "country",
        "feature": "countries1",
        "caption_prop": "name",
        "key_prop": (d)=>d.properties["Alpha-2"],
        scale: 0.2,
        projection: function() { return d3.geoMercator(); },
        translation: [0.5, 0.5],
        rotation: [0,0],
        center: [0,0]
    },
    "world-continents.json": {
        "class": "country",
        "feature": "continent",
        "caption_prop": "continent",
        "key_prop": (d)=>d.properties.continent,
        "scale": 0.2,
        projection: function() { return d3.geoMercator(); },
        translation: [0.5, 0.5],
        rotation: [0,0],
        center: [0,0]
    },
    "countries/italy/italy-regions.json": {
        "class": "country",
        "feature": "ITA_adm1",
        "caption_prop": "NAME_1",
        "key_prop": (d)=>d.properties.ID_1,
        "scale": 2.5,
        projection: function() { return d3.geoAlbers(); },
        translation: [0.5, 0.5],
        rotation: [0,0],
        center: [12.56738,41.87194]
    },
    "countries/italy/italy-provinces.json": {
        "class": "country",
        "feature": "ITA_adm2",
        "caption_prop": "NAME_2",
        "key_prop": (d)=> { let m = d.properties.HASC_2.slice(3); return m == "MA" ? "MI" : m; },
        "scale": 2.5,
        projection: function() { return d3.geoAlbers(); },
        translation: [0.5, 0.5],
        rotation: [0,0],
        center: [12.56738,41.87194]
    }
};

var choropleth_chart = {
    init:function create_choropleth(chart_info, dimfield, dimpivot, valuefield, click_callback) {
        var json_def = uly.api.start().follow_with_cache("uly:static", uly.api.asset_cache, {"rel":"misc/"+ chart_info.map_file});
        var map_definition = map_defs[chart_info.map_file];
        var initialised = false;

        var chart = function(selection) {
            console.error("please don't call this, instead call this.initialisation_func");
        };
        chart.initialisation_func = function initialise_choropleth(selector) {
            // var width = $(selector).width();
            // var height = $(selector).height();
            // console.log("Got width,height", width, height, selector);

            // var projection = d3.geo[map_definition.projection]()
            //     .scale(map_definition.scale * width)
            //     .translate([map_definition.translation[0] * width, map_definition.translation[1] * height]);
            // console.log("Got projection:", projection);
            // var path = d3.geo.path()
            //     .projection(projection);
            
            // //var o_path = path;
            // //path = function(object) { var res = o_path(object); return res; };

            // var svg = $(selector).append($("<svg ></svg>"));
        };
        chart.update_data = (data) => { return [data, null]; };

        chart.update_data_func = function update_choropleth(selector, data) {
            
            json_def.done(function(map) {


                var map_features = null;
                if (typeof map.features == "undefined") {
                    map_features = topojson.feature(map, map.objects[map_definition.feature]).features;
                } else {
                    map_features = map.features;
                }
                
                var width = $(selector).width();
                var height = width * 0.5;

                var projection = map_definition.projection()
                    .center(map_definition.center)
                    .rotate(map_definition.rotation)
                    //.fitSize([width, height], map_features);
                    .scale(map_definition.scale * width)
                    .translate([map_definition.translation[0] * width, map_definition.translation[1] * height])
                uly.projection = projection; uly.d3 = d3;

                var path = d3.geoPath(projection);

                var chart_data = chart.massage_data(data);
                var domain = d3.extent(chart_data, (d) => d.value);
                var colourScale = d3.scaleSequential(d3.interpolateBlues).domain(domain);
                var quantized = d3.scaleQuantize().domain(domain).range(d3.schemeBlues[9]);
    
                const leg_x  = d3.scaleLinear()
                .domain(d3.extent(quantized.domain()))
                .rangeRound([width * 0.6, width * 0.9]);
                const leg_format = d3.format(".1f");
                //                var d3_selection = d3.select(selector).selectAll("svg").data(chart_data);
                console.log("map massaged data:", chart_data);
                $(selector).empty();

                
                var svg = d3.select(selector).append("svg").attr("width", width).attr("height", width*0.5).call(
                    d3.zoom()/*.on("zoom",() => {
                        svg.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
                        console.log("transform:", svg.attr("transform"));
                    })*/
                );
            const leg = svg.append("g")
                .attr("transform", "translate(0,40)");
            console.log(quantized.range().map(d => quantized.invertExtent(d)));
            leg.selectAll("rect")
              .data(quantized.range().map(d => quantized.invertExtent(d)))
              .enter().append("rect")
                .attr("height", 8)
                .attr("x", d => leg_x(d[0]))
                .attr("width", d => leg_x(d[1]) - leg_x(d[0]))
                .attr("fill", d => quantized(d[0]));
            leg.append("text")
                .attr("class", "caption")
                .attr("x", leg_x.range()[0])
                .attr("y", -6)
                .attr("fill", "#000")
                .attr("text-anchor", "start")
                .attr("font-weight", "bold")
                .text(data.title);
          
            leg.call(d3.axisBottom(leg_x)
                .tickSize(13)
                .tickFormat(leg_format)
                .tickValues(quantized.range().slice(1).map(d => quantized.invertExtent(d)[0])))
              .select(".domain")
                .remove();

                var g = svg.append("g").attr("class", "map");

                var tooltip = d3.select(selector).append("div").attr("class", "d3_tooltip hidden").attr("style", "position:absolute;");

                var selection = d3.select(selector).select("svg");

                var data_hash = {};

                selection.select("g.map").attr("class", "countries").attr("style", "fill:none")
                    .selectAll(".country")
                    .data(map_features)
                    .enter()
                      .append("path")
                      .attr("class", "country")
                      .attr("stroke", "black")
                      .attr("fill", (d) => {
                        var datum = chart_data.filter((val) => map_definition.key_prop(d) == val.id );
                        if (datum.length) {
                            datum = datum[0];
                            data_hash[map_definition.key_prop(d)] = datum;
                            var col = datum.colour;
                            console.log(datum, datum.value, colourScale(datum.value));
                            return colourScale(datum.value);
                        }
                        else return "#d0d0d0";
                      
                       }
                    )
                      /*.attr("style", function(d) {
                        if (d.id == "BMU") 
                            return "display:none;";
                        else {
                            var datum = chart_data.filter((val) => map_definition.key_prop(d) == val.id );
                            if (datum.length) {
                                datum = datum[0];
                                data_hash[map_definition.key_prop(d)] = datum;
                                var col = datum.colour;
                                return "fill:"+col+";stroke:black";
                            }
                            else return "fill:#d0d0d0;stroke:black;";
                        }
                    })*/
                    .attr("id", function(d) { return "country_" + map_definition.key_prop(d); })
                    .attr("d", function(d) { if (map_definition.key_prop(d) == "AFG") { console.log("item:", d, path(d)); } return path(d); })
                    .on("click", function(d) {
                        var clicked_id = map_definition.key_prop(d);
                        if (clicked_id && data_hash[clicked_id]) {
                            return click_callback({"point":data_hash[clicked_id].datum});
                        }
                    }).on("mousemove",function(d,i) {
                        var d_id = map_definition.key_prop(d);
                        var mouse = d3.mouse(svg.node()).map( function(d) { return parseInt(d); } );
                        var datum = data_hash[d_id];
                        console.log(d, datum, d_id, mouse);
                        if (datum) {
                            var left = Math.min(width-12*datum.name.length, (mouse[0]+20));
                            var top = Math.min(height-40, (mouse[1]+20));
                            if (datum.datum && (datum.name || datum.value)) {
                                tooltip.classed("hidden", false)
                                    .attr("style", "position:absolute;left:"+left+"px;top:"+top+"px")
                                    .html(datum.name + " [" + datum.value + "]");                            
                            }
                        }
                    }).on("mouseout", function(d,i) {
                        tooltip.classed("hidden",true);
                    });
            });
        };
        chart.massage_data = function(data) {
            var scale = function(i) {
                return d3.schemeSet3[i%d3.schemeSet3.length];
            };

            var i = 0;
            console.log(dimfield, valuefield[0].value, chart_info);
            return $.map(data, function(datum, idx) {
                return {
                    "name":datum[chart_info.map[dimfield]],
                    "id":datum[chart_info.map[dimfield+"_2"]],
                    "value":datum[chart_info.map[valuefield[0].value]],
                    "colour": scale(i++),
                    "datum": datum
                };
            });
        };
        return chart;
    }
};
export default choropleth_chart;
